import React, { useState } from 'react';
import PropTypes from 'prop-types';
import reactHtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';
import ObjectIcon from '../shared/ObjectIcon';

import './RequiredTimeField.scss';
import { Tooltip } from '../shared/Tooltip';
import colors from '../../utils/colors';
import Svg from '../shared/Svg';

export const RequiredTimeField = ({ label, value, objectType, handleChange, selectedRecord, setSelectedRecord }) => {
  const allSelectedRecords = useSelector((state) => state.mail.selectedRecords);
  const objectsConfiguredForTime = useSelector((state) => state.time?.config?.objectsConfiguredForTime || []);
  const selectedRecords = Object.fromEntries(Object.entries(allSelectedRecords).filter(([key, obj]) => objectsConfiguredForTime.includes(obj.type)));
  const settings = useSelector((state) => state.mail.settings);
  const displaySettings = settings.objectsAndDisplayFields;
  const [isExpanded, setIsExpanded] = useState(false);
  const [timeObjectType, setTimeObjectType] = useState(objectType || '');
  const timeNamespace = settings?.override?.timeNamespace || 'litify_time';

  const updateTimeRecord = (record) => {
    setSelectedRecord(record);
    setTimeObjectType(record.type);
    setIsExpanded(false);
    handleChange({ target: { name: `${timeNamespace}__lit_Related_Record_ID__c`, value: record.Id } });
  };

  return (
    <div className='required-time-field'>
      <div className='slds-form-element'>
        <label className='slds-form-element__label'>
          <Tooltip textContent="required">
            <abbr className='slds-required'>*</abbr>
          </Tooltip>
          {label}
        </label>
        <div className={`slds-form-element__control ${Object.values(selectedRecords)?.length > 1 && isExpanded ? 'active' : ''}`}>
          <div className='slds-input' disabled={label === 'Primary Related Record' && Object.values(selectedRecords)?.length > 1 ? false : true} onClick={() => setIsExpanded((prev) => !prev)} >
            {timeObjectType && <ObjectIcon className={'required-time-field-record-img'} objectApiName={objectType} />}
            {value}
            {label === 'Primary Related Record' && Object.values(selectedRecords)?.length > 1 &&
              <div className='iconsContainer'>
                <Svg
                  className='required-time-field-folder-down-icon'
                  data='/assets/chevronFull.svg'
                  fill={colors.grey}
                />
              </div>
            }
          </div>
        </div>
        {label === 'Primary Related Record' && Object.values(selectedRecords)?.length > 1 && isExpanded &&
          <div>
            <div className='required-time-field-folders-dropdown'>
              {Object.values(selectedRecords).filter((record) => record.Id !== selectedRecord.Id).map((record, index) => (
                <div key={index} className='slds-form-element__control'>
                  <div className='slds-input' onClick={() => updateTimeRecord(record)}>
                    {record.type && <ObjectIcon className={'required-time-field-record-img'} objectApiName={record.type} />}
                    {reactHtmlParser(record[displaySettings.find((setting) => setting.apiName === record?.type)?.displayFields[0].apiName])}
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      </div>
    </div>
  );
};

RequiredTimeField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  objectType: PropTypes.string,
  handleChange: PropTypes.func,
  selectedRecord: PropTypes.string,
  setSelectedRecord: PropTypes.func,
};
